var _defs, _path, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTenantBg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_38",
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    fill: "#6b7ef2",
    "data-name": "Ellipse 38",
    transform: "translate(.314 .166)"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-3{fill:#fff}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Mask_Group_31",
    clipPath: "url(#prefix__clip-path)",
    "data-name": "Mask Group 31",
    transform: "rotate(-90 30.574 30.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2074",
    "data-name": "Group 2074",
    transform: "rotate(90 151.992 44.761)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1521",
    d: "M244.355 131.926v-.483a58.542 58.542 0 0 0-34.49-53.35L88.078 7.839A58.512 58.512 0 0 0 8.156 29.285l-.323.561a58.518 58.518 0 0 0 4.774 65.512A58.274 58.274 0 0 0 .092 131.531v.618a58.272 58.272 0 0 0 12.666 36.325 58.605 58.605 0 0 0-4.778 65.669l.238.412a58.6 58.6 0 0 0 80.055 21.42L212.3 184.31a58.7 58.7 0 0 0 32.057-52.248v-.135z",
    className: "prefix__cls-3",
    "data-name": "Path 1521",
    transform: "translate(21.406 21.399)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_3927",
    width: 117.708,
    height: 244.261,
    fill: "#938aa8",
    "data-name": "Rectangle 3927",
    rx: 58.854,
    transform: "rotate(90 85.718 180.02)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_3928",
    width: 117.673,
    height: 263.587,
    fill: "#39bbfc",
    "data-name": "Rectangle 3928",
    rx: 58.836,
    transform: "rotate(60 50.992 234.178)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_3929",
    width: 117.673,
    height: 263.587,
    fill: "#ff4d7f",
    "data-name": "Rectangle 3929",
    rx: 58.836,
    transform: "rotate(119.979 105.522 148.775)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_35",
    cx: 58.836,
    cy: 58.836,
    r: 58.836,
    fill: "#ba6aff",
    "data-name": "Ellipse 35",
    opacity: 0.6,
    transform: "translate(148.088 94.486)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_36",
    cx: 25.104,
    cy: 25.104,
    r: 25.104,
    className: "prefix__cls-3",
    "data-name": "Ellipse 36",
    transform: "translate(181.821 128.223)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_37",
    cx: 10.198,
    cy: 10.198,
    r: 10.198,
    fill: "#43264f",
    "data-name": "Ellipse 37",
    transform: "translate(196.726 143.127)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantBg1);
export default __webpack_public_path__ + "static/media/tenant_bg1.6b09e63a8f3f3bf3becf8186b68e326c.svg";
export { ForwardRef as ReactComponent };